import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const MenuItemsPage = lazy(() =>
  import('./pages/MenuItemsPage').then((module) => ({ default: module.MenuItemsPage })),
);

/**
 * Menu maintainer. `navigation.view_menu_item` opens it; the editing
 * controls inside additionally check `navigation.manage_menu_item`.
 */
export const navigationRoutes: RouteObject[] = [
  {
    path: 'configuracion/menu',
    element: createElement(ProtectedRoute, { view: 'menuItems' }),
    children: [{ index: true, element: createElement(MenuItemsPage) }],
  },
];
